import { useRef } from 'react'

import helper from '@utils/helper';
import { formatPrettyValue } from '@utils/index';
export const useSellForm = (params) => {
  const { marginBalance, isLimit, form, coinDetail, assetCoinDetail } = params;
  const maxAvblAndSpotAvblRef = useRef({
    maxAvbl: '--',
    spotAvbl: '--'
  })
  const getCoin = () => coinDetail?.coinCode?.split('_')?.[0] || '';

  // 卖方向 最大可用
  const renderMaxAvbl = () => {
    let value = '--';
    if (typeof marginBalance?.()?.additional === 'undefined') {
      maxAvblAndSpotAvblRef.current.maxAvbl = value
      return `${value} ${getCoin()}`
    }

    const additional = marginBalance?.()?.additional < 0 ? 0 : marginBalance?.()?.additional;
    const precision = coinDetail?.tradePrecision;
    const unwindSellQty = Math.abs(marginBalance?.()?.unwindSellQty ?? 0);
    if (!isLimit) {
      value = helper.formatFixNumString(Number(additional) / Number(coinDetail?.bid) + unwindSellQty, precision) || '--'
      maxAvblAndSpotAvblRef.current.maxAvbl = value
      return `${formatPrettyValue(value)} ${getCoin()}`
    }

    const limitPrice = form.getFieldValue('price');
    if (!(Number(limitPrice) > 0)) {
      maxAvblAndSpotAvblRef.current.maxAvbl = value
      return `${formatPrettyValue(value)} ${getCoin()}`
    }

    if (Number(limitPrice) < Number(coinDetail?.bid)) {
      value = helper.formatFixNumString(Number(additional) / Number(coinDetail?.bid) + unwindSellQty, precision)
    } else {
      value = helper.formatFixNumString(Number(additional) / Number(limitPrice) + unwindSellQty, precision)
    }
    maxAvblAndSpotAvblRef.current.maxAvbl = value
    return `${formatPrettyValue(value)} ${getCoin()}`
  }

  // 卖方向 现货余额
  const renderSpotAvbl = () => {
    let value = '--'
    if (typeof marginBalance?.()?.quoteAvailable === 'undefined') {
      maxAvblAndSpotAvblRef.current.spotAvbl = value
      return `${value} ${getCoin()}`
    }
    if (marginBalance?.()?.baseAvailable > 0) {
      value = helper.formatFixNumString(marginBalance?.()?.baseAvailable ?? 0, assetCoinDetail?.showKeepDecimalForCoin ?? 8)
      maxAvblAndSpotAvblRef.current.spotAvbl = value
      return `${formatPrettyValue(value)} ${getCoin()}`
    }
    maxAvblAndSpotAvblRef.current.spotAvbl = 0
    return `${0} ${getCoin()}`
  }

  // 卖方向 预估借
  const renderEstimateBorrow = () => {
    let isRender = false;
    const marginSelected = form.getFieldValue('marginSelected');
    const orderTotal = form.getFieldValue('orderTotal');
    const baseQty = form.getFieldValue('baseQty')
    const baseAvailable = marginBalance?.()?.baseAvailable > 0 ? marginBalance?.()?.baseAvailable : 0
    if (marginBalance?.()?.openMargin && marginSelected && baseQty - baseAvailable > 0) {
      isRender = true
    }

    let value = '--'
    if (orderTotal && baseQty) {
      value = 0
      if (baseQty - baseAvailable > 0) {
        value = helper.formatFixNumString(baseQty - baseAvailable, coinDetail?.tradeInputPrecision)
      }
    }
    return {
      isRender,
      text: `${value} ${getCoin()}`
    }
  }
  return {
    renderMaxAvbl,
    renderSpotAvbl,
    renderEstimateBorrow,
    maxAvblAndSpotAvblRef
  }
}
